//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: ${({ width = "100%" }) => width};
    position: relative;
    & > div {
        width: 100%;
        box-sizing: border-box; 
    }
`;